module.exports = __webpack_public_path__ + "img/sponsorA06.34c47511.png";